import { CircularProgress, Typography } from '@mui/material';

type CompanyChainInfoProps = {
  isLoadingCustomers: boolean;
  customers: any;
};

export const CompanyChainInfo = ({
  isLoadingCustomers,
  customers,
}: CompanyChainInfoProps) => {
  const isCustomers = customers && customers.length > 0;

  return (
    <>
      {isLoadingCustomers ? (
        <CircularProgress size={18} thickness={5} />
      ) : isCustomers ? (
        `Yritysketju sisältää ${customers.length} asiakasta`
      ) : (
        <Typography variant="body1" color="red">
          Yritysketjulla ei ole yhtään asiakasta
        </Typography>
      )}
    </>
  );
};
